var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownChevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61138 5.84086L0.160979 1.44079C-0.0536598 1.22858 -0.0536598 0.884535 0.160979 0.672347L0.680047 0.159153C0.89432 -0.0526955 1.24159 -0.0531033 1.45637 0.158247L5.00001 3.64538L8.54363 0.158247C8.75841 -0.0531033 9.10568 -0.0526955 9.31995 0.159153L9.83902 0.672347C10.0537 0.884558 10.0537 1.2286 9.83902 1.44079L5.38864 5.84086C5.174 6.05305 4.82602 6.05305 4.61138 5.84086Z",
    fill: "#C62B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownChevron);
export default __webpack_public_path__ + "static/media/down-chevron.7df6b63c372345aa3174bfeee1f431c7.svg";
export { ForwardRef as ReactComponent };